import { Route, Routes } from '@angular/router';
import { PRIVATE_ROUTE_PATH } from './private.routes';

export function redirectPrivateRoute(path: string): Route {
  return {
    path: path,
    redirectTo: `${PRIVATE_ROUTE_PATH}/${path}`,
    pathMatch: 'full'
  };
}

export const PRIVATE_REDIRECT_ROUTES: Routes = [
  redirectPrivateRoute('account-history'),
  redirectPrivateRoute('activity-reload'),
  redirectPrivateRoute('account-history/check'),
  redirectPrivateRoute('account-history/detail'),
  redirectPrivateRoute('account-history/memo-post-detail'),
  redirectPrivateRoute('account-history/voucher-list'),
  redirectPrivateRoute('account/floats'),
  redirectPrivateRoute('account/holds'),
  redirectPrivateRoute('available-activities'),
  redirectPrivateRoute('batch-order-upload'),
  redirectPrivateRoute('batch-order-manage'),
  redirectPrivateRoute('biometrics'),
  redirectPrivateRoute('cash'),
  redirectPrivateRoute('change-password/:reason'),
  redirectPrivateRoute('cheque'),
  redirectPrivateRoute('contact-us'),
  redirectPrivateRoute('corporate/make-payment'),
  redirectPrivateRoute('corporate/payment-history'),
  redirectPrivateRoute('corporate/manage-customer'),
  redirectPrivateRoute('cross-currency-transfer'),
  redirectPrivateRoute('customer-information/:reason'),
  redirectPrivateRoute('dashboard'),
  redirectPrivateRoute('demo/text'),
  redirectPrivateRoute('download-history'),
  redirectPrivateRoute('download-statement'),
  redirectPrivateRoute('draft'),
  redirectPrivateRoute('draftAutomated'),
  redirectPrivateRoute('eft'),
  redirectPrivateRoute('external-links/:linkId'),
  redirectPrivateRoute('external-transfer-history'),
  redirectPrivateRoute('help-desk'),
  redirectPrivateRoute('id-scan'),
  redirectPrivateRoute('internal-transfer'),
  redirectPrivateRoute('manage-payees'),
  redirectPrivateRoute('manage-payees/add-peers'),
  redirectPrivateRoute('manage-payees/delete-peers'),
  redirectPrivateRoute('manage-payees/update-peers'),
  redirectPrivateRoute('manage-payees/add-merchants'),
  redirectPrivateRoute('manage-payees/delete-merchants'),
  redirectPrivateRoute('manage-payees/update-merchants'),
  redirectPrivateRoute('manage-payees/add-topup-recipients'),
  redirectPrivateRoute('manage-payees/delete-topup-recipients'),
  redirectPrivateRoute('manage-payees/update-topup-recipients'),
  redirectPrivateRoute('manage-payees/add-external-payees'),
  redirectPrivateRoute('manage-payees/delete-external-payees'),
  redirectPrivateRoute('manage-payees/update-external-payees'),
  redirectPrivateRoute('manage-payees/add-domestic-payees'),
  redirectPrivateRoute('manage-payees/delete-domestic-payees'),
  redirectPrivateRoute('manage-payees/update-domestic-payees'),
  redirectPrivateRoute('mobile-cheque-deposit'),
  redirectPrivateRoute('mobile-location-map'),
  redirectPrivateRoute('mobile-queue'),
  redirectPrivateRoute('order-history'),
  redirectPrivateRoute('payment/domestic'),
  redirectPrivateRoute('payment/external'),
  redirectPrivateRoute('payment/general'),
  redirectPrivateRoute('payment-history'),
  redirectPrivateRoute('payment/report'),
  redirectPrivateRoute('payment/topup'),
  redirectPrivateRoute('payroll-batch-upload'),
  redirectPrivateRoute('payroll-department'),
  redirectPrivateRoute('payroll-department-group'),
  redirectPrivateRoute('payroll-manage-batches'),
  redirectPrivateRoute('payroll-manage-members'),
  redirectPrivateRoute('pending-transactions'),
  redirectPrivateRoute('pending-signature'),
  redirectPrivateRoute('personal-finance-management'),
  redirectPrivateRoute('personal-finance-management-landing'),
  redirectPrivateRoute('personal-finance-offers'),
  redirectPrivateRoute('qr-create'),
  redirectPrivateRoute('qr-main'),
  redirectPrivateRoute('qr-payment'),
  redirectPrivateRoute('resource-viewer'),
  redirectPrivateRoute('scheduled-orders'),
  redirectPrivateRoute('scheduled-transactions'),
  redirectPrivateRoute('secure-message'),
  redirectPrivateRoute('security-question'),
  redirectPrivateRoute('services/applications'),
  redirectPrivateRoute('services/applications-create'),
  redirectPrivateRoute('services/applications/new-account'),
  redirectPrivateRoute('services/applications/personal-loan'),
  redirectPrivateRoute('services/applications/self-registration'),
  redirectPrivateRoute('services/applications/car-second'),
  redirectPrivateRoute('services/applications/mortgage-cash'),
  redirectPrivateRoute('services/applications/emergency-psa'),
  redirectPrivateRoute('services/applications/personal-school'),
  redirectPrivateRoute('services/card'),
  redirectPrivateRoute('services/card/change-address'),
  redirectPrivateRoute('services/card/report-lost'),
  redirectPrivateRoute('services/card/manage-debit-card'),
  redirectPrivateRoute('services/card/debit-card-reset-pin'),
  redirectPrivateRoute('services/card/debit-card-change-pin'),
  redirectPrivateRoute('services/card/manage-credit-card'),
  redirectPrivateRoute('services/card/credit-card-reset-pin'),
  redirectPrivateRoute('services/card/credit-card-change-pin'),
  redirectPrivateRoute('services/multi-card/manage-credit'),
  redirectPrivateRoute('services/multi-card/manage-debit'),
  redirectPrivateRoute('services/multi-card/manage-multi-card'),
  redirectPrivateRoute('services/multi-card/manage/:activity'),
  redirectPrivateRoute('services/request'),
  redirectPrivateRoute('services/smart-forms'),
  redirectPrivateRoute('settings/admin'),
  redirectPrivateRoute('settings/admin/manage-payees'),
  redirectPrivateRoute('settings/admin/manage-payees/delete-merchants'),
  redirectPrivateRoute('settings/admin/manage-payees/add-merchants'),
  redirectPrivateRoute('settings/admin/manage-payees/update-merchants'),
  redirectPrivateRoute('settings/alerts'),
  redirectPrivateRoute('settings/personal'),
  redirectPrivateRoute('settings/personal/alias'),
  redirectPrivateRoute('settings/personal/changeEmail'),
  redirectPrivateRoute('settings/personal/changePassword'),
  redirectPrivateRoute('settings/personal/changeSecurityQuestion'),
  redirectPrivateRoute('settings/personal/mobileId'),
  redirectPrivateRoute('settings/personal/viz-alias'),
  redirectPrivateRoute('settings/preference'),
  redirectPrivateRoute('settings/preference/timezone'),
  redirectPrivateRoute('settings/preference/marketing'),
  redirectPrivateRoute('settings/preference/text-message'),
  redirectPrivateRoute('settings/preference/language'),
  redirectPrivateRoute('settings/reset-push'),
  redirectPrivateRoute('stop-payment'),
  redirectPrivateRoute('support-center'),
  redirectPrivateRoute('templates'),
  redirectPrivateRoute('templates/create'),
  redirectPrivateRoute('templates/edit'),
  redirectPrivateRoute('terms-and-conditions'),
  redirectPrivateRoute('tools'),
  redirectPrivateRoute('transfers-by-text'),
  redirectPrivateRoute('transfers-by-text-add'),
  redirectPrivateRoute('transfers-by-text-update'),
  redirectPrivateRoute('view-maintenance'),
  redirectPrivateRoute('viz-history'),
  redirectPrivateRoute('viz-payee-add'),
  redirectPrivateRoute('viz-payee-delete'),
  redirectPrivateRoute('viz-payee-update'),
  redirectPrivateRoute('viz-send-money'),
  redirectPrivateRoute('viz-settings'),
  redirectPrivateRoute('voice-command'),
  redirectPrivateRoute('wire'),
];